<template>
	<el-dialog
		title="手动发货"
		:visible.sync="visible"
		width="640px"
		center
		append-to-body
		@close="handleClose"
	>
		<el-form ref="form" :model="form" label-width="90px" size="small">
			<div v-for="(row, index) in form.packs" :key="index" class="pack_row">
				<div class="pack_row_head">
					<span>运单 {{ index + 1 }}</span>
					<el-button
						v-if="form.packs.length > 1"
						type="text"
						class="pack_remove"
						@click="removeRow(index)"
					>删除</el-button>
				</div>
				<el-form-item
					label="快递公司"
					:prop="'packs.' + index + '.delivery_id'"
					:rules="[{ required: true, message: '请选择快递公司', trigger: 'change' }]"
				>
					<el-select
						v-model="row.delivery_id"
						placeholder="请选择快递公司"
						filterable
						style="width: 100%;"
						:loading="companyLoading"
					>
						<el-option
							v-for="item in companies"
							:key="item.delivery_id"
							:label="item.delivery_name"
							:value="item.delivery_id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item
					label="运单号"
					:prop="'packs.' + index + '.waybill_id'"
					:rules="[{ required: true, message: '请输入运单号', trigger: 'blur' }]"
				>
					<el-input v-model="row.waybill_id" placeholder="请输入运单号" clearable />
				</el-form-item>
			</div>
			<div class="pack_actions">
				<el-button
					type="text"
					icon="el-icon-plus"
					:disabled="form.packs.length >= maxPacks"
					@click="addRow"
				>添加运单</el-button>
				<span v-if="form.packs.length >= maxPacks" class="muted">最多 {{ maxPacks }} 条</span>
			</div>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="submitting" @click="handleConfirm">确 认</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'manualDeliverDialog',
	data() {
		return {
			visible: false,
			targetItem: null,
			companies: [],
			companyLoading: false,
			submitting: false,
			onSuccess: null,
			maxPacks: 10,
			form: {
				packs: [{ delivery_id: '', waybill_id: '' }],
			},
		}
	},
	methods: {
		open(item, onSuccess = null) {
			this.targetItem = item
			this.onSuccess = onSuccess
			this.form = {
				packs: [{ delivery_id: '', waybill_id: '' }],
			}
			this.visible = true
			this.loadCompanies()
			this.$nextTick(() => {
				if (this.$refs.form) {
					this.$refs.form.clearValidate()
				}
			})
		},
		loadCompanies() {
			if (this.companies.length > 0) {
				return
			}
			this.companyLoading = true
			this.$store.dispatch('wxshopDelivery/getDeliveryCompaniesAction', {
				success: (res) => {
					this.companyLoading = false
					if (res.code === 200) {
						this.companies = Array.isArray(res.data?.companies) ? res.data.companies : []
					}
				},
				error: () => {
					this.companyLoading = false
				},
			})
		},
		addRow() {
			if (this.form.packs.length >= this.maxPacks) {
				return
			}
			this.form.packs.push({ delivery_id: '', waybill_id: '' })
		},
		removeRow(index) {
			if (this.form.packs.length <= 1) {
				return
			}
			this.form.packs.splice(index, 1)
		},
		handleConfirm() {
			if (!this.targetItem) {
				return
			}
			this.$refs.form.validate((valid) => {
				if (!valid) {
					return
				}
				const packs = this.form.packs.map((row) => ({
					delivery_id: String(row.delivery_id || '').trim(),
					waybill_id: String(row.waybill_id || '').trim(),
				}))
				const waybills = packs.map((p) => p.waybill_id)
				if (new Set(waybills).size !== waybills.length) {
					this.$message.error('运单号不能重复')
					return
				}
				this.submitting = true
				this.$store.dispatch('wxshopDelivery/postManualDeliverAction', {
					data: {
						wx_order_id: this.targetItem.wx_order_id,
						shop_id: this.targetItem.shop_id,
						packs,
					},
					success: (res) => {
						this.submitting = false
						if (res.code === 200) {
							const partial = res.data && res.data.partial
							this.$message({
								type: partial ? 'warning' : 'success',
								message: res.msg || res.message || (partial ? '部分发货成功' : '发货成功'),
							})
							this.visible = false
							if (typeof this.onSuccess === 'function') {
								this.onSuccess(res)
							}
						} else {
							this.$message.error(res.msg || res.message || '发货失败')
						}
					},
					error: (err) => {
						this.submitting = false
						this.$message.error(err?.msg || err?.message || '发货失败')
					},
				})
			})
		},
		handleClose() {
			this.visible = false
			this.submitting = false
		},
	},
}
</script>

<style scoped>
.pack_row {
	border: 1px solid #ebeef5;
	border-radius: 4px;
	padding: 12px 12px 4px;
	margin-bottom: 12px;
}
.pack_row_head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
	font-weight: 500;
}
.pack_remove {
	color: #f56c6c;
}
.pack_actions {
	padding-left: 90px;
}
.muted {
	color: #909399;
	font-size: 12px;
	margin-left: 8px;
}
</style>
